import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ListColumn } from 'src/@fury/shared/list/list-column.model';
import { Confirmation } from 'src/app/enums/confirmation.enum';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { PartnersRoute } from 'src/app/enums/partners-route.enum';
import { ApiService } from 'src/app/services/api.service';
import { PartnerActionComponent } from 'src/app/shared/partner-action/partner-action.component';
import { ReviewComponent } from 'src/app/shared/review/review.component';
import { VendorFormComponent } from 'src/app/shared/vendor-form/vendor-form.component';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterFormModal, FilterValue } from 'src/app/models/form-group.model';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'fury-pending-real-estate-professional-list',
  templateUrl: './pending-real-estate-professional-list.component.html',
  styleUrls: ['./pending-real-estate-professional-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class PendingRealEstateProfessionalListComponent implements OnInit {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  columns: any =  [
    { name: 'Name', property: 'name', visible: true },
    { name: 'SUBMITTED ON', property: 'createdAt', visible: true },
    { name: 'Phone', property: 'phoneNumber', visible: true },
    { name: 'Email', property: 'emailAddress', visible: true, isModelProperty: true },
    { name: 'Company Name', property: 'companyName', visible: true },
    { name: 'Company Email', property: 'companyEmail', visible: true },
    { name: 'Status', property: 'status', visible: true },
    { name: 'Actions', property: 'actions', visible: true },
  ];
  
  searchedKeyword!: string; 
  dataSource: MatTableDataSource<any[]> = new MatTableDataSource<any[]>([]);
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  pageType: string = 'real-estate-professionals';
  pageSize = 30;
  totalCount: any = 0;
  pageIndex: any = 0;
  dataSetList: any;
  partnersRoute = PartnersRoute;
  filterValue!: string;
  searchBy: string = 'fullName';
  searchType: string = 'contains';
  isShowFilter: boolean = false;

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });
  constructor(
    private dialog: MatDialog,
    private apiService: ApiService,
    private router: Router,
    private activatedroute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    public commonService: CommonService
  ) {
    this.activatedroute.queryParams.subscribe((res: any) => {
      this.pageIndex = res.page ? Number(res.page) - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30; 
      this.searchBy = res.searchBy ? res.searchBy : 'fullName';
      this.searchType = res.searchType ? res.searchType : 'contains';
      this.filterForm.patchValue({
        searchBy: this.searchBy,
        searchType: this.searchType
      });        
      this.getDatasetList();
    });
    
  }

  get visibleColumns() {
    return this.columns.filter((column: any) => column.visible).map((column: any) => column.property)
  }
  ngOnInit(): void {
    this.filterValue = 'Pending Real Estate Professionals'
  }

  getDatasetList() {
    this.apiService.get(`admin/partner/get-real-estate-professionals?status=pending&page=${Number(this.pageIndex + 1)}&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`).subscribe((res: any) => {
      if (res.body) {
        if (res.body?.realEstateProfessionals) {
          this.dataSetList = res.body.realEstateProfessionals.data;
          this.totalCount = res.body.realEstateProfessionals.total;          
          this.dataSource = new MatTableDataSource(this.dataSetList);          
          
        } else {
          this.dataSetList = [];
          this.dataSource = new MatTableDataSource(this.dataSetList);
          this.totalCount = res.body.realEstateProfessionals.total;
        }
      }
    });
  }

 
  pageSizeChange(event: any) {   
    this.pageIndex = event.pageIndex ;
    this.pageSize = event.pageSize;
    this.router.navigateByUrl(`/partners/real-estate-professionals/pending?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.getDatasetList();
  }

  onFilterChange(value: string) {
    if (!this.dataSource) { return } else {
      this.pageIndex = 0;
      this.searchedKeyword = value.trim();
      this.router.navigateByUrl(`/partners/real-estate-professionals/pending?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
      this.getDatasetList();
    }
  }

  delete(type: string, row: any) {
    const dialogref = this.dialog.open(PartnerActionComponent, { width: '500px', data: { type, row } });
    dialogref.afterClosed().subscribe((res: Confirmation) => {
      if (res === Confirmation.Yes) {
        this.apiService.delete(`admin/partner/delete-partner/${row?.realEstateProfessionalId}`).subscribe((del: any) => {
          if (del.body) {
            this.apiService.alert(del.body.message, ErrorType.Success);
            this.getDatasetList();
          }
        }, err => {
          if (err) {
            this.apiService.alert(ErrorText.SomeThingWentWrong, ErrorType.Error);
          }
        });
      }
    });
  }

  editRealtor(row: any) {
    this.dialog.open(VendorFormComponent, {
      data: Object.assign({ pageType: this.pageType }, row)
    }).afterClosed().subscribe(result => {
      if (result) {
        this.getDatasetList();
      }
    })
  }
  reviewApplication(row: any) {
    this.dialog.open(ReviewComponent, {
      data: row
    }).afterClosed().subscribe((result: PartnersRoute) => {
      if (result) {
        const dataSet = { userId: row?.realEstateProfessionalId, status: result.toLowerCase() }
        this.apiService.patch('admin/partner/change-partner-status', dataSet).subscribe((res: any) => {
          if (res) {
            this.apiService.alert(res.body.message, ErrorType.Success);
            this.getDatasetList();
          } else {
            this.apiService.alert(res.body.message, ErrorType.Warning);
          }
        }, err => {
          if (err) {
            Object.keys(err.errors).map((error) => {
              this.apiService.alert(err.errors[error], ErrorType.Error);
            })
          }
        });
      }
    });
  }
  ngAfterViewInit(): void {
    
  }

  showFilter(){
    this.isShowFilter = !this.isShowFilter; 
  }
  serchByValue: FilterValue[] = [
    {title: 'Full Name', value: 'fullName'},
    {title: 'Phone Number', value: 'phoneNumber'},
    {title: 'Email Address', value: 'emailAddress'},
    {title: 'Company Name', value: 'companyName'},
    {title: 'Company Email', value: 'companyEmail'}
  ];
  filterChange(){
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(`/partners/real-estate-professionals/pending?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.isShowFilter = false;
    this.getDatasetList();
  }


}
